// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer__footer___j9fkZ {
    display: flex;
    justify-content: flex-end;
    padding: 1.2rem;
    border-top: 0.1rem solid var(--color-bg-border);
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,+CAA+C;AACnD","sourcesContent":[".footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 1.2rem;\n    border-top: 0.1rem solid var(--color-bg-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer__footer___j9fkZ`
};
export default ___CSS_LOADER_EXPORT___;
